(()=>{
  const galleries=new WeakMap();
  const stickyPurchases=new WeakMap();
  function initializeStickyPurchase(root){
    if(stickyPurchases.has(root))return;
    const bar=root.querySelector('[data-re-mobile-purchase]');
    const form=root.querySelector('.re-purchase-form');
    const price=root.querySelector('[data-re-price]');
    if(!bar||!form||!price)return;
    const mobile=window.matchMedia('(max-width: 749px)');
    const stickyPrice=bar.querySelector('[data-re-sticky-price]');
    const actions=Array.from(bar.querySelectorAll('[data-re-sticky-action]')).map(button=>({
      button,source:form.querySelector(button.dataset.reStickyAction==='buy'?'[data-re-buy-now]':'[name="add"]')
    }));
    if(!stickyPrice||actions.some(action=>!action.source))return;
    function sync(){
      stickyPrice.textContent=price.textContent;
      for(const {button,source} of actions){
        button.textContent=source.textContent;
        button.disabled=source.disabled;
      }
    }
    let frame=0;
    function updateVisibility(){
      frame=0;
      bar.hidden=!mobile.matches||form.getBoundingClientRect().bottom>0;
    }
    function schedule(){if(!frame)frame=window.requestAnimationFrame(updateVisibility);}
    for(const {button,source} of actions){
      button.addEventListener('click',()=>{
        if(!source.disabled)form.requestSubmit(source);
      });
    }
    const observer=new MutationObserver(()=>{sync();schedule();});
    observer.observe(form,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    observer.observe(price,{subtree:true,childList:true,characterData:true});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    window.addEventListener('pageshow',schedule);
    bar.dataset.ready='true';
    sync();
    updateVisibility();
    stickyPurchases.set(root,()=>{
      observer.disconnect();
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',schedule);
      window.removeEventListener('pageshow',schedule);
      stickyPurchases.delete(root);
    });
  }
  function initializeGallery(root){
    if(galleries.has(root))return galleries.get(root);
    const link=root.querySelector('.re-pdp-main-image');
    const image=link?.querySelector('img');
    if(!image)return null;
    const caption=root.querySelector('[data-re-gallery-caption]');
    const thumbnails=Array.from(root.querySelectorAll('[data-re-gallery-image]'));
    const images=thumbnails.map(item=>({id:item.dataset.reGalleryImage,src:item.dataset.reSrc,srcset:item.dataset.reSrcset,full:item.href,alt:item.querySelector('img')?.alt||''}));
    const initial={id:link.dataset.reMainImage,src:image.getAttribute('src'),srcset:image.getAttribute('srcset'),alt:image.alt,full:link.href};
    function show(next){
      if(!next)return;
      image.src=next.src;
      if(next.srcset)image.setAttribute('srcset',next.srcset);else image.removeAttribute('srcset');
      image.alt=next.alt||'';
      link.href=next.full;
      link.dataset.reMainImage=String(next.id);
      for(const thumbnail of thumbnails){
        if(thumbnail.dataset.reGalleryImage===String(next.id))thumbnail.setAttribute('aria-current','true');
        else thumbnail.removeAttribute('aria-current');
      }
      if(caption)caption.textContent=next.alt.toLowerCase().includes('lifestyle mockup')?root.dataset.reStyledLabel:'';
    }
    for(const thumbnail of thumbnails){
      thumbnail.addEventListener('click',event=>{
        if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        const next=images.find(item=>item.id===thumbnail.dataset.reGalleryImage);
        if(!next)return;
        event.preventDefault();
        show(next);
      });
    }
    const sizeLink=root.querySelector('[data-re-size-link]');
    sizeLink?.addEventListener('click',()=>{
      const details=root.querySelector('.re-size-detail');
      if(details)details.open=true;
    });
    const gallery={show,initial,backForColor:color=>images.find(item=>item.alt.includes(' in '+color+' — back view'))};
    galleries.set(root,gallery);
    show(initial);
    return gallery;
  }

  function initialize(root){
    const gallery=initializeGallery(root);
    root.querySelector('[data-re-buy-now]')?.removeAttribute('hidden');
    initializeStickyPurchase(root);
    const picker=root.querySelector('[data-re-option-picker]');
    if(!picker||picker.dataset.ready==='true')return;
    const dataNode=root.querySelector('[data-re-option-data]');
    const fallback=root.querySelector('[data-re-variant-fallback]');
    const legacy=fallback?.querySelector('[data-re-variant]');
    const form=picker.closest('form');
    const color=picker.querySelector('[data-re-color]');
    const size=picker.querySelector('[data-re-size]');
    const id=picker.querySelector('[data-re-selected-id]');
    const status=picker.querySelector('[data-re-option-status]');
    const button=form?.querySelector('[name="add"]');
    const buyNow=form?.querySelector('[data-re-buy-now]');
    const price=root.querySelector('[data-re-price]');
    let data;
    try{data=JSON.parse(dataNode.textContent);}catch{return;}
    if(!legacy||!form||!color||!size||!id||!status||!button||!price||!Array.isArray(data.variants))return;
    const variants=data.variants;
    const sizeValues=Array.from(size.options).map(option=>option.value).filter(Boolean);
    const sameColor=()=>variants.filter(variant=>!color.value||variant.color===color.value);
    const selected=()=>variants.find(variant=>variant.color===color.value&&variant.size===size.value);
    function showImage(next){gallery?.show(gallery.backForColor(color.value)||next);}
    function fillSizes(value=''){
      if(data.fixedSize)value=data.fixedSize;
      const placeholder=new Option(data.text.chooseSize,'',false,!value);
      placeholder.disabled=true;
      const options=[placeholder];
      const matches=sameColor();
      sizeValues.forEach(sizeValue=>{
        const candidates=matches.filter(item=>item.size===sizeValue);
        const variant=candidates.find(item=>item.available)||candidates[0];
        if(!variant)return;
        const option=new Option(sizeValue+(variant.available?'':' · '+data.text.soldOut),sizeValue,false,sizeValue===value);
        option.disabled=!variant.available;
        options.push(option);
      });
      size.replaceChildren(...options);
      size.disabled=false;
      if(!options.some(option=>option.value===value&&!option.disabled))size.value='';
    }
    const alert=document.createElement('p');
    alert.className='re-selection-alert';
    alert.setAttribute('role','alert');
    alert.hidden=true;
    form.querySelector('.re-purchase-actions').before(alert);
    let attempted=false;
    function updateAlert(){
      const missingColor=!color.value;
      const missingSize=!size.value;
      const invalid=missingColor||missingSize;
      alert.hidden=!attempted||!invalid;
      alert.textContent=invalid?(missingColor&&missingSize?data.text.chooseBoth:missingColor?data.text.chooseColor:data.text.chooseSize):'';
      for(const control of [color,size]){
        const missing=!control.value&&attempted;
        control.setAttribute('aria-invalid',String(missing));
        const group=control.parentElement.querySelector('.re-choice-group');
        if(group)group.classList.toggle('re-selection-missing',missing);
      }
    }
    function update(updateUrl=true){
      updateAlert();
      const variant=selected();
      const valid=Boolean(variant?.available);
      id.value=valid?variant.id:'';
      id.disabled=!valid;
      button.disabled=!variants.some(item=>item.available)||Boolean(variant&&!valid);
      if(buyNow){
        buyNow.disabled=button.disabled;
        buyNow.textContent=buyNow.disabled?data.text.soldOut:buyNow.dataset.reBuyLabel;
      }
      if(variant){
        button.textContent=valid?data.text.add:data.text.soldOut;
        price.textContent=variant.priceText;
        status.textContent=data.text.selected+' '+variant.title+(valid?'':' · '+data.text.soldOut);
        showImage(variant.image);
      }else{
        button.textContent=data.text.add;
        status.textContent=color.value?data.text.chooseSize:(size.value?data.text.chooseColor:data.text.chooseBoth);
        const matches=sameColor();
        const available=matches.filter(item=>item.available);
        const shown=available.length?available:matches;
        if(shown.length){
          const lowest=shown.reduce((min,item)=>item.price<min.price?item:min);
          const varies=shown.some(item=>item.price!==lowest.price);
          price.textContent=(varies?data.text.from+' ':'')+lowest.priceText;
          if(color.value)showImage(shown[0].image);
        }else{
          price.textContent=data.defaultPrice;
          showImage(gallery?.initial);
        }
      }
      if(updateUrl){
        const url=new URL(window.location.href);
        if(variant)url.searchParams.set('variant',variant.id);else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state,'',url.toString());
      }
    }
    Array.from(color.options).filter(option=>option.value).forEach(option=>{
      const available=variants.some(variant=>variant.color===option.value&&variant.available);
      option.disabled=!available;
      if(!available)option.textContent+=' · '+data.text.soldOut;
    });
    function syncFromUrl(){
      const requested=new URL(window.location.href).searchParams.get('variant');
      const variant=variants.find(item=>item.id===requested);
      color.value=variant?variant.color:'';
      fillSizes(variant?variant.size:'');
      update(false);
    }
    const initial=variants.find(variant=>variant.id===data.initialVariant);
    color.value=initial?initial.color:'';
    fillSizes(initial?initial.size:'');
    update(false);
    color.required=false;
    size.required=false;
    legacy.disabled=true;
    fallback.hidden=true;
    picker.hidden=false;
    picker.dataset.ready='true';
    color.addEventListener('change',()=>{
      fillSizes(size.value);
      update();
    });
    size.addEventListener('change',()=>update());
    form.addEventListener('submit',event=>{
      const variant=selected();
      if(!variant?.available||id.value!==variant.id){
        event.preventDefault();
        attempted=true;
        update(false);
        const control=color.value?size:color;
        const choices=control.parentElement.querySelector('.re-choice-group');
        const target=choices?.querySelector('button:not(:disabled)')||control;
        target.focus();
        target.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
    });
    window.addEventListener('popstate',syncFromUrl);
    window.addEventListener('pageshow',event=>{if(event.persisted)syncFromUrl();});
  }
  function mount(scope=document){
    if(scope.matches?.('[data-re-product]'))initialize(scope);
    scope.querySelectorAll('[data-re-product]').forEach(initialize);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount());else mount();
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    if(event.target.matches?.('[data-re-product]'))stickyPurchases.get(event.target)?.();
    event.target.querySelectorAll('[data-re-product]').forEach(root=>stickyPurchases.get(root)?.());
  });
  document.addEventListener('submit',event=>{
    const button=event.submitter;
    if(!button?.matches('[data-re-buy-now]')||event.defaultPrevented)return;
    event.preventDefault();
    const form=event.target;
    if(!form.reportValidity())return;
    const fields=new FormData(form);
    const variant=String(fields.get('id')||'');
    const quantity=Number(fields.get('quantity')||1);
    if(!/^\d+$/.test(variant)||!Number.isSafeInteger(quantity)||quantity<1)return;
    const url=new URL(button.dataset.reCartUrl,window.location.origin);
    url.pathname=url.pathname.replace(/\/$/,'')+'/'+variant+':'+quantity;
    const discount=new URL(window.location.href).searchParams.get('discount');
    if(discount)url.searchParams.set('discount',discount);
    window.location.assign(url.toString());
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-re-variant]')&&!event.target.disabled&&event.target.value){
      const url=new URL(window.location.href);
      url.searchParams.set('variant',event.target.value);
      window.location.assign(url.toString());
    }
  });
})();
